// /hooks/use-mobile.ts
"use client";
import { useEffect, useState } from "react";

/**
 * Hook ตรวจสอบว่า viewport ปัจจุบันเป็นขนาด “mobile” หรือไม่
 * @param breakpoint จุดตัด (px) — ถ้า width < breakpoint => ถือเป็น mobile
 */
export function useIsMobile(breakpoint: number = 768): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") {
      // ใน SSR, เราต้องกำหนดค่าเริ่มต้น (ใน client มันจะถูกอัปเดตใน useEffect)
      return false;
    }
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    function onResize() {
      setIsMobile(window.innerWidth < breakpoint);
    }

    window.addEventListener("resize", onResize);
    // คุณอาจจะเพิ่ม “orientationchange” ก็ได้
    window.addEventListener("orientationchange", onResize);

    // เรียกครั้งแรก
    onResize();

    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, [breakpoint]);

  return isMobile;
}
